// extracted by mini-css-extract-plugin
module.exports = {"PublicationPage_container":"PublicationPage_PublicationPage_container__iWCg8","PublicationPage_content":"PublicationPage_PublicationPage_content__LrHWi"};